import axios from "axios";
import { apiObjUrl } from "src/common/apiUrl";
import { stdParamsSerializer } from "src/common/rest";
import type { TableStore } from "src/components/tables/TableStore";
import { formatSortParam } from "src/components/tables/utils/formatParams";
import type { EntityFilters, ZEntityRow } from "../types";

type ExportTable = Pick<
  TableStore<ZEntityRow, EntityFilters>,
  "filters" | "finalColumns" | "params" | "selected"
>;

export const createExportUrl = (store: ExportTable, lang: string): string => {
  const params = {
    objectId: store.filters?.objectId,
    stateIds: store.filters?.stateIds,
    dictionaryValueIds: JSON.stringify(store.filters?.dictionaryValueIds || []),
    hierarchicalFilter: JSON.stringify(store.filters?.hierarchicalFilter || {}),
    query: store.filters?.query,
    sorting: formatSortParam(store.params) ?? undefined,
    columnIds: store.finalColumns.map(({ key }) => key),
    entityIds: store.selected.map(({ id }) => id),
    lang,
  };

  return axios.getUri({
    url: apiObjUrl("/v3/entities/export"),
    params,
    paramsSerializer: stdParamsSerializer,
  });
};
